export default "__VITE_ASSET__CZt_6vqO__"